// i18n area 'auth' — locale da-DK (task #171, onda 2): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/auth.da-DK.meta.json.
import type { enUS } from './auth'

export const daDK: typeof enUS = {
  login: {
    welcome: 'Trantor TVirt v6',
    subtitle: 'Log ind på din konto',
    username: 'Brugernavn',
    usernamePlaceholder: 'Indtast brugernavnet',
    usernameHint: 'Brug bruger@domæne for at autentificere dig mod et directory-realm',
    continue: 'Fortsæt',
    changeUser: 'Er det ikke dig?',
    password: 'Adgangskode',
    forgotPassword: 'Glemt adgangskode?',
    submit: 'Log ind',
    otp: 'Engangskode',
    otpSubtitle: 'Indtast koden fra din autentifikator',
    otpHint: 'Seks cifre fra autentifikator-appen, eller en af gendannelseskoderne',
    otpSubmit: 'Verificer',
    invalidCredentials: 'Ugyldigt brugernavn eller adgangskode',
    tooManyAttempts: 'For mange forsøg — vent et øjeblik, og prøv igen',
    realmUnavailable: 'Realmet kan ikke verificere legitimationen lige nu — clusterets store kan ikke nås. Log ind som lokal bruger (break-glass).',
    genericError: 'Login mislykkedes — kan TVirt-backenden nås?'
  },
  user: {
    logout: 'Log ud',
    password: {
      menu: 'Skift adgangskode',
      title: 'Skift din adgangskode',
      current: 'Nuværende adgangskode',
      new: 'Ny adgangskode',
      confirm: 'Bekræft den nye adgangskode',
      mismatch: 'Adgangskoderne stemmer ikke overens',
      error: 'Kunne ikke skifte adgangskoden',
      forcedTitle: 'Skift adgangskoden for at fortsætte',
      forcedHint: 'Denne adgangskode blev sat af en administrator og skal erstattes, før du kommer ind.',
      forcedSubmit: 'Skift og log ind'
    },
    mfa: {
      title: 'Tofaktorautentificering',
      subtitle: 'En anden faktor kræves ved hvert login',
      loadError: 'Kunne ikke indlæse den anden faktors status',
      enrolled: 'Aktiv',
      notEnrolled: 'Ikke aktiv',
      enrolledAt: 'Aktiveret den',
      codesRemaining: 'Resterende gendannelseskoder',
      requiredHint: 'En administrator kræver den anden faktor på denne konto: konfigurer den nu — indtil du gør det, kan du logge ind, men ikke meget andet.',
      enroll: 'Konfigurer',
      enrollTitle: 'Konfigurer tofaktorautentificering',
      enrollHint: 'Scan denne kode med autentifikator-appen, og indtast så koden, den viser, for at bekræfte.',
      secretHint: 'Kan du ikke scanne den? Indtast denne hemmelighed i appen:',
      code: 'Kode fra appen',
      confirm: 'Bekræft',
      startError: 'Kunne ikke starte konfigurationen',
      confirmError: 'Kunne ikke bekræfte konfigurationen',
      codesTitle: 'Dine gendannelseskoder',
      codesWarning: 'Disse koder vises kun én gang. Gem dem nu: hver af dem logger dig ind, når autentifikatoren ikke er tilgængelig, og gælder kun én gang.',
      codesAck: 'Jeg har gemt gendannelseskoderne',
      codesDone: 'Færdig',
      copy: 'Kopier',
      copied: 'Kopieret',
      download: 'Download',
      regenerate: 'Nye gendannelseskoder',
      regenerateTitle: 'Regenerer gendannelseskoderne',
      regenerateHint: 'Alle hidtil udstedte koder holder op med at virke i det øjeblik, det nye sæt genereres.',
      regenerateConfirm: 'Regenerer',
      regenerateError: 'Kunne ikke regenerere gendannelseskoderne',
      remove: 'Fjern',
      removeTitle: 'Fjern den anden faktor',
      removeConfirm: 'Fjern',
      removeHint: 'Kontoen vender tilbage til kun adgangskode. Du kan konfigurere den anden faktor igen, når du vil.',
      removeRequiredHint: 'En administrator kræver den anden faktor på denne konto, så serveren vil afvise fjernelsen — bed først om at få kravet fjernet.',
      removeError: 'Kunne ikke fjerne den anden faktor'
    },
    profile: {
      menu: 'Gå til min profil',
      sessions: 'Aktive sessioner',
      sessionsHint: 'Dine åbne sessioner på denne node',
      sessionsEmpty: 'Ingen aktive sessioner',
      sessionCreated: 'Logget ind',
      sessionExpires: 'Udløber',
      revoke: 'Tilbagekald session',
      revokeError: 'Kunne ikke tilbagekalde sessionen',
      loadError: 'Kunne ikke indlæse sessionerne'
    }
  }
}
